import React, { Fragment } from 'react';
import PropTypes from 'prop-types';
import s from './PersonalDataFields.module.scss';
import Field from 'Components/Field';
import Select from 'Components/Select';

const PersonalDataFields = ({
    register,
    control,
    errors,
    countries,
}) => {
    let defaultCountry = countries.filter(x => x.value === 'SE');
    defaultCountry = defaultCountry.length ? defaultCountry[0] : null;

    return (
        <Fragment>
            <Field
                name="firstName"
                label="Förnamn"
                required={true}
                control={control}
                register={register('firstName')}
                errors={errors}
            />

            <Field
                name="lastName"
                label="Efternamn"
                required={true}
                control={control}
                register={register('lastName')}
                errors={errors}
            />

            <Field
                name="address"
                label="Adressrad 1"
                required={true}
                control={control}
                register={register('address')}
                errors={errors}
            />

            <Field
                name="address2"
                label="Adressrad 2"
                control={control}
                register={register('address2')}
            />

            <Field
                name="postalCode"
                label="Postnummer"
                required={true}
                control={control}
                register={register('postalCode')}
                errors={errors}
            />

            <Field
                name="city"
                label="Ort"
                required={true}
                control={control}
                register={register('city')}
                errors={errors}
            />

            <Select
                name="country"
                label="Land"
                options={countries}
                control={control}
                required={true}
                errors={errors}
                register={register('country')}
                defaultValue={defaultCountry}
            />
        </Fragment>
    );
};

PersonalDataFields.propTypes = {
    register: PropTypes.func,
    control: PropTypes.object,
    errors: PropTypes.object,
    countries: PropTypes.array,
};

PersonalDataFields.defaultProps = {
    register: null,
    control: {},
    errors: {},
    countries: [],
};

export default PersonalDataFields;
